export default __webpack_public_path__ + "static/media/h31koritu.a88f0d91.mp3";